import * as Yup from "yup";

// Règles identiques à celles de l'API (utils/passwordValidation.utils.ts et
// validators/register.validator.ts) : au moins 8 caractères, une minuscule,
// une majuscule, un chiffre et un caractère spécial.
export const PASSWORD_HINT =
  "Au moins 8 caractères, avec une minuscule, une majuscule, un chiffre et un caractère spécial.";

const SPECIAL_CHAR_REGEX = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]/;

export const strongPasswordSchema = Yup.string()
  .required("Mot de passe requis")
  .min(8, "Minimum 8 caractères")
  .matches(/[a-z]/, "Au moins une minuscule")
  .matches(/[A-Z]/, "Au moins une majuscule")
  .matches(/\d/, "Au moins un chiffre")
  .matches(SPECIAL_CHAR_REGEX, "Au moins un caractère spécial (ex : ! @ # $ %)");
